import { useContext } from "react";
import { AuthContext } from "../store/auth-context.js";

export default function useAuth() {
  return useContext(AuthContext);
}
